/* eslint-disable react/prop-types, complexity */
import React, { useState } from 'react';

import { Col, Row, Spin } from 'antd';
import cn from 'classnames';

import ActivityTreePane from '#components/ActivityTreePane/ActivityTreePane.jsx';
import TaktVisualization from '#components/TaktVisualization/index.js';
import useWindowDimensions from '#hooks/useWindowDimensions.js';
import { lookaheadActions } from '#redux/actions/lookaheadActions.js';
import { ganttAPI } from '#utils/customGanttPlugin.js';
import { isFeatureOn } from '#utils/featureUtils.js';

export function TaktView({
  activeActivityTreePane,
  activities,
  activitiesTreePanel,
  antIcon,
  currentActivityHidden,
  dateRange,
  defaultView,
  filterSettings,
  getLookahead,
  groupBy,
  handleAddConstraint,
  handleUnfit,
  history,
  isLoading,
  isReloadDataViews,
  onDoubleClickTask,
  permission,
  setActiveActivityTreePane,
  setActivityTreePaneSettings,
  subContracts,
  t,
  tableConfig,
  taktRelations,
  updateRender
}) {
  const [scrollTaktPosition, setScrollTaktPosition] = useState({
    top: 0,
    left: 0
  });

  const { height } = useWindowDimensions();

  return (
    <Row>
      <Col
        style={{ height: height - 192 }}
        className={cn({
          'activity-pane__container':
            isFeatureOn('enable-LWP-103') &&
            activeActivityTreePane &&
            !isLoading
        })}>
        {isFeatureOn('enable-LWP-103') &&
          activeActivityTreePane &&
          !isLoading && (
            <ActivityTreePane
              activities={activitiesTreePanel}
              actitySettings={defaultView.current.activityTreeSettings}
              closePane={setActiveActivityTreePane}
              onCommandDispach={getLookahead}
              filterSettings={filterSettings}
              viewId={defaultView.current.id}
              setActivityTreePaneSettings={setActivityTreePaneSettings}
              isReloadDataViews={isReloadDataViews}
              t={t}
              currentActivityHidden={currentActivityHidden}
            />
          )}
        {isReloadDataViews && (
          <div>
            <Spin
              className="loader-spinner-lookahead-table"
              indicator={antIcon}
            />
          </div>
        )}
        {!isReloadDataViews && (
          <TaktVisualization
            scrollTaktPosition={scrollTaktPosition}
            setScrollTaktPosition={setScrollTaktPosition}
            onDoubleClickTask={onDoubleClickTask}
            ganttAPI={ganttAPI}
            groupByActivity={groupBy.criteria === 'activityId'}
            taktRelations={taktRelations}
            handleUnfit={handleUnfit}
            permission={permission}
            handleAddConstraint={handleAddConstraint}
            markersDates={dateRange}
            actions={lookaheadActions}
            stateToExtract={'lookaheadState'}
            data={activities}
            subContracts={subContracts}
            t={t}
            history={history}
            updateRender={updateRender}
            tableConfig={tableConfig}
          />
        )}
      </Col>
    </Row>
  );
}
